import {useContext} from 'react'
import {DayItemsContext} from './DayItemsContext'

export const useDayItems = () => {
  const contextInstance = useContext(DayItemsContext)
  if (!contextInstance) throw new Error('Cannot call useDayItems() outside of <DayItemsProvider>')
  return contextInstance
}
